import { render } from "./tournament_time_plate_component.vue?vue&type=template&id=3b0d46ca"
import script from "./tournament_time_plate_component.vue?vue&type=script&lang=js"
export * from "./tournament_time_plate_component.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__